import { render, staticRenderFns } from "./ChannelVideoClaims.vue?vue&type=template&id=0b764401"
import script from "./ChannelVideoClaims.vue?vue&type=script&lang=js"
export * from "./ChannelVideoClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports